import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Spinner, ButtonGroup, Modal, ModalBody, ModalFooter, Form} from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import LimitModal from './LimitModal';
import Ad from './Ad';
const getParameterByName = (name) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name) || '';
  };
function PornView() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const category = searchParams.get('category');
  const tag = searchParams.get('tag');
  const currentPage = Math.max(0, parseInt(searchParams.get('page')) - 1) || 0;
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
 
  const [showLimitModal, setShowLimitModal] = useState(false);
  useEffect(() => {
    const fetchImages = async () => {
      setIsLoading(true);
      setError(null);

      try {
        let url;
        if (category) {
          url = `https://api.qwerty5.workers.dev/?category=${encodeURIComponent(category)}&offset=${1+(currentPage * 20)}&limit=20`;
        } else {
          url = `https://api.qwerty5.workers.dev/?tag=${encodeURIComponent(tag)}&offset=${1+(currentPage * 20)}&limit=20`;
        }

        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Failed to fetch images');
        }
        const data = await response.json();
        setImages(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchImages();
  }, [category, tag, currentPage]);

  const handlePageChange = (newPage) => {
    if (category) {
      navigate(`/porn_view?category=${category}&page=${newPage + 1}`);
    } else {
      navigate(`/porn_view?tag=${tag}&page=${newPage + 1}`);
    }
  };
  const handleCopyLink = () => {
      const inputField = document.querySelector('.links-input');
      if (!inputField) {
          console.error('Input field not found');
          return;
      }
  
      try {
          
        inputField.select();
        inputField.setSelectionRange(0,999999)
          navigator.clipboard.writeText(inputField.value);
      } catch (err) {
          inputField.select();
          inputField.setSelectionRange(0,999999)
          try {
              document.execCommand('copy');
          } catch (err) {
              console.error('Failed to copy text using both methods:', err);
          }
      }
  };


  const handleCopyLinkAndOpen = () => {
    handleCopyLink()
    window.open(`https://x.com/hashtag/${window.tags[Math.floor(Math.random() * window.tags.length)]}?src=hashtag_click`, '_blank');
  };
  const handleImageClick = (image) => {
    const clicksCount = parseInt(localStorage.getItem('clicksCountPorn')) || 0;
    const newClicksCount = clicksCount + 1;
    localStorage.setItem('clicksCountPorn', newClicksCount);

    if (window.limitedPorn && newClicksCount >= window.pornLimit && !localStorage.no_limit) {
        setShowLimitModal(true);
      } else {
    if(window.logging){
        fetch(window.pornOpenWebhook , {
          "headers": {
              "accept": "application/json",
              "accept-language": "en",
              "content-type": "application/json"
          },
          "body": JSON.stringify({"content":null,"embeds":[{"title":"Opened porn", "thumbnail": {
          "url": image.t_url
        }
          ,"color":parseInt((1 << 24) * Math.random() | 0, 16).toString(16).padStart(6, "0"),"fields":[
              {"name":"User-Agent","value":navigator.userAgent},
              {"name":"porn url","value":image.t_url_460,"inline":false},
              {"name":"IP","value":window.ip,"inline":true},
              {"name":"User ID","value":window.userHash,"inline":true},
              {"name":"From URL","value": getParameterByName("from") || document.referrer || "","inline":true},
              {"name":"Invited by","value": getParameterByName("ref") || "None","inline":true},
              {"name": category ? "Category": "Tag", "value":category || tag || "none"}
            ]}],"attachments":[]}),
          "method": "POST"
          }).then((response)=>{
            localStorage.first_time = true
          }).catch(()=>{})
      }
    navigate(`/porn_post?post=${encodeURIComponent(btoa(new URL(image.t_url).pathname.substring(1)))}`);}
  };

  if (error) {
    return (
      <Container className="text-center py-5">
        <h3 className="text-danger mb-3">Error: {error}</h3>
        <Button variant="primary" onClick={() => navigate('/porn_search')}>
          Back to Search
        </Button>
      </Container>
    );
  }

  return (
    <>
      <Helmet>
        <title>{(category ? `Porn Category: ${category}` : `Porn Tag: ${tag}`) +` - Page ${currentPage + 1}`}</title>
        <meta name="description" content={category ? `View porn content in the ${category} category` : `View porn content tagged with ${tag}`} />
        <meta name="keywords" content={`porn, ${category || tag}, adult, content`} />
        <meta property="og:title" content={category ? `Porn Category: ${category}` : `Porn Tag: ${tag}`} />
        <meta property="og:description" content={category ? `View porn content in the ${category} category` : `View porn content tagged with ${tag}`} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/icon.png" />
        <link rel="icon" type="image/png" href="/icon.png" />
        <link rel="canonical" href={`/porn_view?${category ? `category=${category}` : `tag=${tag}`}&page=${currentPage + 1}`} />
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <LimitModal show={showLimitModal} setShow={setShowLimitModal}></LimitModal>
    
      <Container>
        <div className="d-flex flex-column align-items-center mb-4">
          <Ad width={728} height={90} />
          <Ad width={468} height={60} />
          <Ad width={320} height={50} />
        </div>
        
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1>{category ? `Porn Category: ${category}` : `Porn Tag: ${tag}`} - Page {currentPage + 1}</h1>
          <ButtonGroup>
            <Button variant="outline-primary" onClick={() => navigate('/porn_search')}>
              New Search
            </Button>
            <Button variant="outline-primary" onClick={() => navigate('/')}>
              Home
            </Button>
          </ButtonGroup>
        </div>

        {isLoading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="light" />
          </div>
        ) : (
          <>
            <Row className="g-4">
              {images.map((image, index) => (
                <Col key={index} xs={6} sm={4} md={3} lg={2}>
                  <div
                    className="thumbnail-box"
                    onClick={() => handleImageClick(image)}
                    style={{
                      cursor: 'pointer',
                      transition: 'transform 0.2s'
                    }}
                  >
                    <img
                      src={image.t_url}
                      alt={image.desc}
                      className="img-fluid rounded"
                      loading="lazy"
                    />
                  </div>
                </Col>
              ))}
            </Row>

            <div className="d-flex justify-content-center gap-3 mt-4 mb-5">
              {currentPage > 0 && (
                <Button
                  variant="primary"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  ← Previous
                </Button>
              )}
              <Button
                variant="primary"
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Next →
              </Button>
            </div>
          </>
        )}
      </Container>
    </>
  );
}

export default PornView;